import { useState } from 'react'

import styles from './Calendar.module.scss'
import cx from 'classnames'

const filterMock = ['all', 'sharks', 'whales', 'turtles', 'others']

const CalendarFilter = ({ handleFilter, isHidden }) => {
  const [active, setActive] = useState('all')

  if(isHidden) {
    return null
  }

  const handleClick = (event, filterName) => {
    event.preventDefault()
    setActive(filterName)
    handleFilter(filterName)
  }

  return (
    <div className={styles.filters}>
      {filterMock.map((filter) => (
        <button
          key={filter}
          className={cx(styles.filter, {
            [styles.active]: filter === active,
          })}
          onClick={(e) => handleClick(e, filter)}
        >
          {filter}
        </button>
      ))}
    </div>
  )
}

export default CalendarFilter
